

import axios from 'axios';

// Apna backend base URL set karein
const API_URL = process.env.REACT_APP_API_URL
const axiosInstance = axios.create({
  baseURL: `${API_URL}/api`,
});

// Request Interceptor: Har API call se pehle ye token attach karega
axiosInstance.interceptors.request.use(
  (config) => {
    // Check both 'authToken' and 'token' in localStorage
    const token = localStorage.getItem('authToken') || localStorage.getItem('token');

    if (token && token !== "secured_token") {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: 401 Unauthorized response check karne ke liye
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      const isRevoked =
        error.response.data?.code === "SESSION_REVOKED" ||
        (typeof error.response.data?.message === "string" &&
          error.response.data.message.includes("another device"));

      if (isRevoked) {
        sessionStorage.setItem(
          "session_revoked_notice",
          error.response.data?.message || "Your account was logged in on another device."
        );
      }

      console.warn("Unauthorized request detected! Clearing session and redirecting to login.");
      localStorage.removeItem("authToken");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("userIsPremium");

      // Redirect to login if not already on the login page
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;